"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScholarshipEligibilityModel = void 0;
const anonymous_student_interfaces_1 = require("@studyportals/anonymous-student-interfaces");
const student_interfaces_1 = require("@studyportals/student-interfaces");
const wishlist_service_core_1 = require("@studyportals/wishlist-service-core");
const requirements_1 = require("../../requirements");
const types_1 = require("../../types");
const eligibility_update_event_1 = require("../../types/eligibility-update-event");
class ScholarshipEligibilityModel {
    constructor(_pathToEnableReviewRequirementCheck) {
        this.eventAggregationService = window.EventAggregationService;
        this.requirements = [];
        this.areDependenciesReady = false;
        this.isFirstTime = false;
        this.startDate = new Date('2024-01-01');
        this.pathToEnableReviewRequirementCheck = _pathToEnableReviewRequirementCheck;
        window.EventAggregationService.subscribeTo(student_interfaces_1.SessionServiceReadyEvent.EventType, this, true);
        window.EventAggregationService.subscribeTo(anonymous_student_interfaces_1.AnonymousStudentServiceReady.EventType, this, true);
        window.EventAggregationService.subscribeTo(student_interfaces_1.WishlistServiceReadyEvent.EventType, this, true);
        window.EventAggregationService.subscribeTo(anonymous_student_interfaces_1.AnonymousStudentProfileSynced.EventType, this, false);
        window.EventAggregationService.subscribeTo(anonymous_student_interfaces_1.AnonymousStudentProfileUpdated.EventType, this, false);
        window.EventAggregationService.subscribeTo(wishlist_service_core_1.FavouriteApplicationStatusChanged.EventType, this, false);
        window.EventAggregationService.subscribeTo(wishlist_service_core_1.FavouriteAdded.EventType, this, false);
        window.EventAggregationService.subscribeTo(wishlist_service_core_1.FavouriteRemoved.EventType, this, false);
    }
    notify(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (event.eventType === student_interfaces_1.SessionServiceReadyEvent.EventType) {
                this.handleSessionServiceReady(event);
            }
            if (event.eventType === anonymous_student_interfaces_1.AnonymousStudentServiceReady.EventType) {
                this.handleAnonymousStudentReady(event);
            }
            if (event.eventType === student_interfaces_1.WishlistServiceReadyEvent.EventType) {
                this.handleWishlistServiceReady(event);
            }
            this.areDependenciesReady = yield this.checkDependencies();
            if (this.checkIfFirstTime()) {
                this.createRequirements();
                window.addEventListener('visibilitychange', this.onTabVisibilityChange.bind(this));
            }
            if (this.areDependenciesReady) {
                yield this.publishEligibilityUpdate();
            }
        });
    }
    checkDependencies() {
        return __awaiter(this, void 0, void 0, function* () {
            const servicesAreNotFullfilled = !this.sessionService || !this.anonymousStudentService || !this.wishlistService;
            if (servicesAreNotFullfilled)
                return false;
            const hasSession = this.sessionService ? yield this.sessionService.getSession() : false;
            if (!hasSession)
                return false;
            return true;
        });
    }
    checkIfFirstTime() {
        if (!this.isFirstTime) {
            this.isFirstTime = true;
            return true;
        }
        return false;
    }
    publishEligibilityUpdate() {
        return __awaiter(this, void 0, void 0, function* () {
            const eligibility = yield this.getEligibility();
            const updatedRequirements = this.getOnlyChangedRequirements(eligibility);
            if (Object.keys(updatedRequirements).length === 0 && this.previousRequirements)
                return;
            this.eventAggregationService.publishTo(eligibility_update_event_1.EligibilityUpdateEvent.EventType, new eligibility_update_event_1.EligibilityUpdateEvent(eligibility, updatedRequirements));
            this.previousRequirements = Object.assign({}, eligibility);
        });
    }
    getOnlyChangedRequirements(currentRequirements) {
        if (!this.previousRequirements) {
            return {};
        }
        const updatedRequirements = {};
        for (const requirement in currentRequirements) {
            const requirementType = requirement;
            if (currentRequirements[requirementType] !== this.previousRequirements[requirementType]) {
                updatedRequirements[requirementType] = currentRequirements[requirementType];
            }
        }
        return updatedRequirements;
    }
    getEligibility() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                [types_1.ScholarshipRequirementType.CREATED_ACCOUNT]: true,
                [types_1.ScholarshipRequirementType.EMAIL_SUBSCRIPTIONS]: yield this.getRequirement(types_1.ScholarshipRequirementType.EMAIL_SUBSCRIPTIONS).isFulfilled(),
                [types_1.ScholarshipRequirementType.STUDY_PREFERENCES]: yield this.getRequirement(types_1.ScholarshipRequirementType.STUDY_PREFERENCES).isFulfilled(),
                [types_1.ScholarshipRequirementType.BEST_FIT]: yield this.getRequirement(types_1.ScholarshipRequirementType.BEST_FIT).isFulfilled(),
                [types_1.ScholarshipRequirementType.REVIEW]: yield this.getRequirement(types_1.ScholarshipRequirementType.REVIEW).isFulfilled(),
                [types_1.ScholarshipRequirementType.APPLIED]: yield this.getRequirement(types_1.ScholarshipRequirementType.APPLIED).isFulfilled(),
                [types_1.ScholarshipRequirementType.APPLICATION_LETTER]: yield this.getRequirement(types_1.ScholarshipRequirementType.APPLICATION_LETTER).isFulfilled(),
                [types_1.ScholarshipRequirementType.CONFIRM_ACCEPTANCE]: yield this.getRequirement(types_1.ScholarshipRequirementType.CONFIRM_ACCEPTANCE).isFulfilled(),
            };
        });
    }
    handleSessionServiceReady(event) {
        this.sessionService = event.sessionService;
    }
    handleAnonymousStudentReady(event) {
        this.anonymousStudentService = event.anonymousStudentService;
    }
    handleWishlistServiceReady(event) {
        this.wishlistService = event.wishlistService;
    }
    createRequirements() {
        this.requirements = [
            new requirements_1.EmailSubscriptionRequirement(this.anonymousStudentService),
            new requirements_1.StudyPreferencesRequirement(this.anonymousStudentService),
            new requirements_1.ReviewRequirement(this.sessionService, this.pathToEnableReviewRequirementCheck),
            new requirements_1.BestFitRequirement(this.anonymousStudentService),
            new requirements_1.AppliedRequirement(this.wishlistService),
            new requirements_1.ApplicationLetterRequirement(this.wishlistService),
            new requirements_1.ConfirmAcceptanceRequirement(this.anonymousStudentService),
        ];
    }
    getRequirement(requirementType) {
        const requirement = this.requirements.find((r) => r.type === requirementType);
        if (requirement) {
            return requirement;
        }
        throw new Error('Invalid requirement type');
    }
    onTabVisibilityChange() {
        if (document.visibilityState !== 'visible' || !this.areDependenciesReady) {
            return;
        }
        void this.publishEligibilityUpdate();
    }
}
exports.ScholarshipEligibilityModel = ScholarshipEligibilityModel;
